var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__policy-links"},_vm._l((_vm.$options.FOOTER_MENU_CENTER),function(link){return _c('a',{key:link.to,on:{"click":function($event){$event.preventDefault();return _vm.$bus.$emit(
        'change.layout',
        'terms',
        ("api/v4/terms" + (link.to) + "/"),
        link.name
      )}}},[_vm._v(" "+_vm._s(link.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }